/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#es-footer[_ngcontent-%COMP%]{height:145px}.version[_ngcontent-%COMP%]{color:#fff;text-align:right;padding-right:15px}\n/*# sourceMappingURL=footer.component.css.map*/"];
export { styles as styles };
